/**
 * Playlist Loader
*/

import URLToolkit from 'url-toolkit';
import Event from '../events';
import EventHandler from '../event-handler';
import { ErrorTypes, ErrorDetails } from '../errors';
import AttrList from '../utils/attr-list';
import { logger } from '../utils/logger';
import DataTypes from '../data-types'; //Mactrix line added
import HlsDateRange from '../../utils/hlsDateRange';


// https://regex101.com is your friend
const MASTER_PLAYLIST_REGEX = /#EXT-X-STREAM-INF:([^\n\r]*)[\r\n]+([^\r\n]+)/g;
const MASTER_PLAYLIST_MEDIA_REGEX = /#EXT-X-MEDIA:(.*)/g;

//Mactric Replaced start
//const LEVEL_PLAYLIST_REGEX_FAST = /#EXTINF:(\d*(?:\.\d+)?)(?:,(.*))?|(?!#)(\S.+)|#EXT-X-BYTERANGE: *(.+)|#EXT-X-PROGRAM-DATE-TIME:(.+)|#.*/g;
//Mactric Replaced end
//Mactrix replacement start
const LEVEL_PLAYLIST_REGEX_FAST = /#EXTINF:(\d*(?:\.\d+)?)(?:,(.*))?|(?!#)(\S.+)|#EXT-X-BYTERANGE: *(.+)|#EXT-X-PROGRAM-DATE-TIME:(.+)|#EXT-X-DATERANGE: *(.+)|#.*/g;
//Mactix replacment end

const LEVEL_PLAYLIST_REGEX_SLOW = /(?:(?:#(EXTM3U))|(?:#EXT-X-(PLAYLIST-TYPE):(.+))|(?:#EXT-X-(MEDIA-SEQUENCE): *(\d+))|(?:#EXT-X-(TARGETDURATION): *(\d+))|(?:#EXT-X-(KEY):(.+))|(?:#EXT-X-(START):(.+))|(?:#EXT-X-(ENDLIST))|(?:#EXT-X-(DISCONTINUITY-SEQ)UENCE:(\d+))|(?:#EXT-X-(DIS)CONTINUITY))|(?:#EXT-X-(VERSION):(\d+))|(?:#EXT-X-(MAP):(.+))|(?:#EXT-X-(GAP))|(?:(#)(.*):(.*))|(?:(#)(.*))(?:.*)\r?\n?/;

class LevelKey {

	constructor() {
		this.method = null;
		this.key = null;
		this.iv = null;
		this._uri = null;
	}

	get uri() {
		if (!this._uri && this.reluri) {
			this._uri = URLToolkit.buildAbsoluteURL(this.baseuri, this.reluri, { alwaysNormalize: true });
		}
		return this._uri;
	}

}

class Fragment {

	constructor() {
		this._url = null;
		this._byteRange = null;
		this._decryptdata = null;
		this.tagList = [];
	}

	get url() {
		if (!this._url && this.relurl) {
			this._url = URLToolkit.buildAbsoluteURL(this.baseurl, this.relurl, { alwaysNormalize: true });
		}
		return this._url;
	}

	set url(value) {
		this._url = value;
	}

	get programDateTime() {
		if (!this._programDateTime && this.rawProgramDateTime) {
			this._programDateTime = new Date(Date.parse(this.rawProgramDateTime));
		}
		return this._programDateTime;
	}

	get byteRange() {
		if (!this._byteRange) {
			let byteRange = this._byteRange = [];
			if (this.rawByteRange) {
				const params = this.rawByteRange.split('@', 2);
				if (params.length === 1) {
					const lastByteRangeEndOffset = this.lastByteRangeEndOffset;
					byteRange[0] = lastByteRangeEndOffset || 0;
				}
				else {
					byteRange[0] = parseInt(params[1], 10);
				}
				byteRange[1] = parseInt(params[0], 10) + byteRange[0];
			}
		}
		return this._byteRange;
	}

	get byteRangeStartOffset() {
		return this.byteRange[0];
	}

	get byteRangeEndOffset() {
		return this.byteRange[1];
	}

	get decryptdata() {
		if (!this._decryptdata) {
			if(!this.levelkeys) {
				if(this.levelkey && this.levelkey.method !== 'SAMPLE-AES' && this.levelkey.method !== 'ISO-23001-7' && this.levelkey.method !== 'SAMPLE-AES-CTR' && this.levelkey.method !== 'SAMPLE-AES-CENC') {
					this._decryptdata = this.fragmentDecryptdataFromLevelkey(this.levelkey, this.sn);
				}

			}
		}
		return this._decryptdata;
	}

  /**
   * Utility method for parseLevelPlaylist to create an initialization vector for a given segment
   * @returns {Uint8Array}
   */
	createInitializationVector(segmentNumber) {
		var uint8View = new Uint8Array(16);

		for (var i = 12; i < 16; i++) {
			uint8View[i] = (segmentNumber >> 8 * (15 - i)) & 0xff;
		}

		return uint8View;
	}

  /**
   * Utility method for parseLevelPlaylist to get a fragment's decryption data from the currently parsed encryption key data
   * @param levelkey - a playlist's encryption info
   * @param segmentNumber - the fragment's segment number
   * @returns {*} - an object to be applied as a fragment's decryptdata
   */
	fragmentDecryptdataFromLevelkey(levelkey, segmentNumber) {
		var decryptdata = levelkey;

		if (levelkey.method && levelkey.uri && !levelkey.iv) {
			decryptdata = new LevelKey();
			decryptdata.method = levelkey.method;
			decryptdata.baseuri = levelkey.baseuri;
			decryptdata.reluri = levelkey.reluri;
			decryptdata.iv = this.createInitializationVector(segmentNumber);
		}

		return decryptdata;
	}

	cloneObj(obj) {
		return JSON.parse(JSON.stringify(obj));
	}
}

class PlaylistLoader extends EventHandler {

	constructor(hls) {
		super( hls,
			Event.ERROR, //Mactrix line added
			Event.MANIFEST_LOADING,
			Event.LEVEL_LOADING,
			Event.AUDIO_TRACK_LOADING,
			Event.SUBTITLE_TRACK_LOADING );

		this.loaders = {};
		this.lastGap = {}; //Mactix line added, track found discos
	}

	destroy() {
		for (let loaderName in this.loaders) { //eslint-disable-line guard-for-in
			let loader = this.loaders[loaderName];
			if (loader) {
				loader.destroy();
			}
		}
		this.loaders = {};
		this.lastGap = {}; //Mactrix line added
		EventHandler.prototype.destroy.call(this);
	}

	onManifestLoading(data) {
		this.load(data.url, { type : 'manifest' });
	}

	onLevelLoading(data) {
		this.load(data.url, { type : 'level', level : data.level, id : data.id });
	}

	onAudioTrackLoading(data) {
		this.load(data.url, { type : 'audioTrack', id : data.id });
	}

	onSubtitleTrackLoading(data) {
		this.load(data.url, { type : 'subtitleTrack', id : data.id });
	}

	//Mactrix additions start
	//on fatal error, abort all loaders
	onError(data) {
		if(data.fatal) {
			for (let loaderName in this.loaders) {
				if(this.loaders[loaderName]) {
					this.loaders[loaderName].abort();
				}
			}
		}
	}
	//Mactrix additions end

	load(url, context) {
		let loader = this.loaders[context.type];
		let config = this.hls.config;
		let retry;
		let timeout;
		let retryDelay;
		let maxRetryDelay;

		if (loader) {
			/*let loaderContext = loader.context;
			if (loaderContext && loaderContext.url === url) {
				logger.trace(`playlist request ongoing`);
				return;
			}
			else {
				logger.warn(`abort previous loader for type:${context.type}`);*/
			loader.abort();
			//}
		}
		else {
			loader = this.loaders[context.type] = context.loader = typeof(config.pLoader) !== 'undefined' ? new config.pLoader(config) : new config.loader(config);
		}

		if(context.type === 'manifest') {
			retry = config.manifestLoadingMaxRetry;
			timeout = config.manifestLoadingTimeOut;
			retryDelay = config.manifestLoadingRetryDelay;
			maxRetryDelay = config.manifestLoadingMaxRetryTimeout;
		}
		else {
			retry = config.levelLoadingMaxRetry;
			timeout = config.levelLoadingTimeOut;
			retryDelay = config.levelLoadingRetryDelay;
			maxRetryDelay = config.levelLoadingMaxRetryTimeout;
			logger.log(`loading playlist for ${context.type} ${context.level || context.id}`);
		}
		context.url = url;
		context.responseType = '';
		context.dataType = DataTypes.MANIFEST; //Mactrix line added, add data type

		let loaderConfig;
		let loaderCallbacks;

		loaderConfig = { timeout : timeout, maxRetry : retry, retryDelay : retryDelay, maxRetryDelay : maxRetryDelay };
		loaderCallbacks = { onSuccess : this.loadsuccess.bind(this), onError :this.loaderror.bind(this), onTimeout : this.loadtimeout.bind(this) };
		loader.load(context, loaderConfig, loaderCallbacks);
	}

	resolve(url, baseUrl) {
		return URLToolkit.buildAbsoluteURL(baseUrl, url, { alwaysNormalize: true });
	}

	parseMasterPlaylist(string, baseurl) {
		let levels = [];
		let result;

		MASTER_PLAYLIST_REGEX.lastIndex = 0;
		//se: poor form.
		while ((result = MASTER_PLAYLIST_REGEX.exec(string)) != null) { //eslint-disable-line no-cond-assign
			const level = {};

			var attrs = level.attrs = new AttrList(result[1]);
			level.url = this.resolve(result[2], baseurl);

			var resolution = attrs.decimalResolution('RESOLUTION');
			if(resolution) {
				level.width = resolution.width;
				level.height = resolution.height;
			}
			level.bitrate = attrs.decimalInteger('AVERAGE-BANDWIDTH') || attrs.decimalInteger('BANDWIDTH');
			level.name = attrs.NAME;

			//Mactrix additions start
			level.audioGroup = attrs.AUDIO; //add audio rendition group support

			//add default level support
			if (levels.length === 0) {
				level.default = true;
			}
			else {
				level.default = false;
			}
			//Mactrix additions end

			var codecs = attrs.CODECS;
			if(codecs) {
				codecs = codecs.split(/[ ,]+/);
				for (let i = 0; i < codecs.length; i++) {
					const codec = codecs[i];
					if (codec.indexOf('avc1') !== -1) {
						level.videoCodec = this.avc1toavcoti(codec);
					}
					else {
						level.audioCodec = codec;
					}
				}
			}

			levels.push(level);
		}
		return levels;
	}

	parseMasterPlaylistMedia(string, baseurl, type) {
		let result;
		let medias = [];
		let id = 0;

		MASTER_PLAYLIST_MEDIA_REGEX.lastIndex = 0;
		//se: poor form.
		while ((result = MASTER_PLAYLIST_MEDIA_REGEX.exec(string)) != null) { //eslint-disable-line no-cond-assign
			const media = {};
			var attrs = new AttrList(result[1]);
			if(attrs.TYPE === type) {
				media.groupId = attrs['GROUP-ID'];
				media.name = attrs.NAME;
				media.type = type;
				media.default = (attrs.DEFAULT === 'YES');
				media.autoselect = (attrs.AUTOSELECT === 'YES');
				media.forced = (attrs.FORCED === 'YES');
				if (attrs.URI) {
					media.url = this.resolve(attrs.URI, baseurl);
				}
				media.lang = attrs.LANGUAGE;
				if(!media.name) {
					media.name = media.lang;
				}
				media.id = id++;
				medias.push(media);
			}
		}
		return medias;
	}

  //Mactrix additions begin
  //alternate renditions parser designed to support rendition groups
	parseMasterPlaylistMediaGrouped(string, baseurl, type) {
		let result;
		let medias = [];
		let id = 0;

		MASTER_PLAYLIST_MEDIA_REGEX.lastIndex = 0;
		//se: poor form.
		while ((result = MASTER_PLAYLIST_MEDIA_REGEX.exec(string)) != null) { //eslint-disable-line no-cond-assign
			const rendition = {};
			var attrs = new AttrList(result[1]);
			if(attrs.TYPE === type) {
				rendition.groupId = attrs['GROUP-ID'];
				if (attrs.URI) {
					rendition.url = this.resolve(attrs.URI, baseurl);
				}
				let added = false;
				for (let i = 0; i < medias.length; i++) {
					if(medias[i].name === attrs.NAME) {
						medias[i].renditions.push(rendition);
						added = true;
					}
				}
				if(!added) {
					const media = {};
					media.name = attrs.NAME;
					media.type = type;
					media.default = (attrs.DEFAULT === 'YES');
					media.autoselect = (attrs.AUTOSELECT === 'YES');
					media.forced = (attrs.FORCED === 'YES');
					media.lang = attrs.LANGUAGE;
					if(!media.name) {
						media.name = media.lang;
					}
					media.id = id++;
					media.renditions = [rendition];
					medias.push(media);
				}
			}
		}
		return medias;
	}
  //Mactrix additions end

	avc1toavcoti(codec) {
		let result;
		let avcdata = codec.split('.');

		if (avcdata.length > 2) {
			result = avcdata.shift() + '.';
			result += parseInt(avcdata.shift(), 10).toString(16);
			result += ('000' + parseInt(avcdata.shift(), 10).toString(16)).substr(-4);
		}
		else {
			result = codec;
		}
		return result;
	}

	parseLevelPlaylist(string, baseurl, id, type) {
		let currentSN = 0;
		let totalduration = 0;
		let level = { type: null, version: null, url: baseurl, fragments: [], live: true, startSN: 0 };
		let levelkeys = [];
		let cc = 0;
		let prevFrag = null;
		let frag = new Fragment();
		let result;
//Mactrix changes begin: store the frag index
		let index = 0;
		let clearKeys = false;
//Mactrix changes end

		LEVEL_PLAYLIST_REGEX_FAST.lastIndex = 0;

		//se: poor form.
		while ((result = LEVEL_PLAYLIST_REGEX_FAST.exec(string)) !== null) { //eslint-disable-line no-cond-assign
			const duration = result[1];
			if (duration) { // INF
				frag.duration = parseFloat(duration);

//Mactrix changes begin: frag.duration is overwritten with transport stream duration
//						 the pdt calculation is based of the manifest duration NOT the
//						 transport stream duration
//						 we need to cache the manifest duration otherwise when comparing
//						 pdts across track switches we get a mismatch where we end up
//						 comparing the transport stream time of the previous frag with the
//						 manifest time (because we haven't read the next chunk yet, hence
//						 frag.duration has not been overwritten) of the current frag
//						 which can result in an incorrect chunk being selected
				frag.manifestDuration = frag.duration;
//Mactrix changes end

		// avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
				const title = (' ' + result[2]).slice(1);
				frag.title = title || null;
				frag.tagList.push(title ? ['INF', duration, title] : ['INF', duration]);

				if(result[2]) {
					let pairs = result[2].split(',');
					let i;

					for(i = 0; i < pairs.length; i++) {
						let pair = pairs[i].split('=');
						pair[0] = pair[0].trim();

						if(pair[0] === 'startDTS') {
							frag.startDTS = parseInt(pair[1], 10);
						}
						else if(pair[0] === 'nextDTS') {
							frag.nextDTS = parseInt(pair[1], 10);
						}
						else if(pair[0] === 'frames') {
							frag.frames = parseInt(pair[1], 10);
						}
					}
				}
			}
			else if (result[3]) { // url
				if (!isNaN(frag.duration)) {
					const sn = currentSN++;
					//Mactrix changes begin
					let length;
					frag.index = index++;
					//Mactrix changes end
					frag.type = type;
					frag.start = totalduration;
					if(levelkeys && levelkeys.length) {
						frag.levelkey = levelkeys[levelkeys.length - 1];
					}
					frag.sn = sn;
					frag.level = id;
					frag.cc = cc;
					frag.baseurl = baseurl;
					// avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
					frag.relurl = (' ' + result[3]).slice(1);

					level.fragments.push(frag);

					//Mactrix changes begin: keep track of the pdt of each frag
					length = level.fragments.length;

					if(frag.rawProgramDateTime) {
						let i;
						frag.pdt = Date.parse(frag.rawProgramDateTime);

						if( length > 1) {
							//determine if there is a gap
							if( level.fragments[length - 2].pdt && level.fragments[length - 2].pdt + level.fragments[length - 2].manifestDuration * 1000 < level.fragments[length - 1].pdt - level.fragments[length - 1].manifestDuration * 500) {
								//there is a gap in the manifest - this is approximate
								//we will use this value to determine whether or a not a gap exists, then make it correct in the tranmux

								/*
									We are going to extend (in the case of video) the duration of the first frame of the next fragment.
									Ideally (from a user perspective) it would be more desirable to extend the last frame of the current
									fragment (level.fragments[length - 2].gap).
									However, this relies on us trusting that the gap calculated via the pdts is frame accurate (which I don't), hence I've
									chosen the safer option.
								*/
								level.fragments[length - 1].gap = level.fragments[length - 1].pdt - (level.fragments[length - 2].pdt + level.fragments[length - 2].manifestDuration * 1000);

								//TODO: once we implement EXT-X-GAP, those are expected gaps and should not require an error
								let identifier = type + id;
								if(this.lastGap[identifier] === undefined || this.lastGap[identifier] < level.fragments[length - 1].pdt) {
									this.lastGap[identifier] = level.fragments[length - 1].pdt;
									let data = {
										type: ErrorTypes.MUX_ERROR,
										details: ErrorDetails.LEVEL_UNEXPECTED_GAP_ERROR,
										fatal: false,
										playlistType: type,
										level: id,
										gapTime: level.fragments[length - 1].start,
										gapStartPdt: level.fragments[length - 2].pdt + level.fragments[length - 2].duration * 1000,
										gapEndPdt: level.fragments[length - 1].pdt,
										gapDuration: level.fragments[length - 1].gap,
									};

									logger.warn(`gap detected in ${type}, level ${id}, time ${data.gapTime}, length ${data.gapDuration / 1000}`);
									this.hls.trigger(Event.ERROR, data);
								}

								if(this.hls.streamController.altAudio === true) {
									totalduration += level.fragments[length - 1].gap / 1000;
								}

								//extend the manifest duration to account for the gap, ideally we would also set the gap here too, but instead set this gap in
								//the next fragment (see block comment above)
								level.fragments[length - 2].manifestDuration += (level.fragments[length - 1].gap / 1000);
							}

							/*
								6.3.3.  Playing the Media Playlist file

								If the first EXT-X-PROGRAM-DATE-TIME tag in a Playlist appears after
								one or more media segment URIs, the client SHOULD extrapolate
								backward from that tag (using EXTINF durations and/or media
								timestamps) to associate dates with those segments.
							*/
							for (i = length - 2; i >= 0 && level.fragments[i].pdt === undefined; i--) {
								level.fragments[i].pdt = level.fragments[i + 1].pdt - level.fragments[i].manifestDuration * 1000;
							}
						}
					}
					else {
						/*
							6.3.3.  Playing the Media Playlist file

							To associate a
							date with any other media segment that does not have an EXT-X
							   -PROGRAM-DATE-TIME tag applied to it directly , the client SHOULD
							   extrapolate forward from the last EXT-X-PROGRAM-DATE-TIME tag
							   appearing before that segment in the Playlist.
						*/
						if(length > 1) {
							if(level.fragments[length - 2].pdt) {
								level.fragments[length - 1].pdt = level.fragments[length - 2].pdt + level.fragments[length - 2].duration * 1000;
							}
						}
					}
//Mactrix changes end

					prevFrag = frag;
					totalduration += frag.duration;

					frag = new Fragment();
				}

				//Any level keys loaded prior to this applies to this fragment.
				//When we load the next set of level keys we need to clear the old ones.
				clearKeys = true;
			}
			else if (result[4]) { // X-BYTERANGE
				frag.rawByteRange = (' ' + result[4]).slice(1);
				if (prevFrag) {
					const lastByteRangeEndOffset = prevFrag.byteRangeEndOffset;
					if (lastByteRangeEndOffset) {
						frag.lastByteRangeEndOffset = lastByteRangeEndOffset;
					}
				}
//Mactrix addition start
			}
			else if (result[6]) { // DATERANGE
				let thisRange = new HlsDateRange(result[6]);
				frag.dateRange = thisRange;
				frag.tagList.push(['DATERANGE', frag.dateRange]);
//Mactrix addition end
			}
			else if (result[5]) { // PROGRAM-DATE-TIME
		// avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
				frag.rawProgramDateTime = (' ' + result[5]).slice(1);
				frag.tagList.push(['PROGRAM-DATE-TIME', frag.rawProgramDateTime]);
			}
			else {
				let i;
				result = result[0].match(LEVEL_PLAYLIST_REGEX_SLOW);
				for ( i = 1; i < result.length; i++) {
					if (result[i] !== undefined) {
						break;
					}
				}

		// avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
				const value1 = (' ' + result[i + 1]).slice(1);
				const value2 = (' ' + result[i + 2]).slice(1);

				switch (result[i]) {
				case '#':
					frag.tagList.push(value2 ? [value1, value2] : [value1]);
					break;
				case 'PLAYLIST-TYPE':
					level.type = value1.toUpperCase();
					break;
				case 'MEDIA-SEQUENCE':
					currentSN = level.startSN = parseInt(value1, 10);
					break;
				case 'TARGETDURATION':
					level.targetduration = parseFloat(value1);
					break;
				case 'VERSION':
					level.version = parseInt(value1, 10);
					break;
				case 'EXTM3U':
					break;
				case 'ENDLIST':
					level.live = false;
					break;
				case 'DIS':
					cc++;
					frag.tagList.push(['DIS']);
					break;
				case 'DISCONTINUITY-SEQ':
					cc = parseInt(value1, 10);
					break;
				case 'GAP':
					frag.tagList.push('GAP');
					break;
				case 'KEY':
					{
						// https://tools.ietf.org/html/draft-pantos-http-live-streaming-08#section-3.4.4
						let decryptparams = value1;
						let keyAttrs = new AttrList(decryptparams);
						let decryptmethod = keyAttrs.enumeratedString('METHOD');
						let decrypturi = keyAttrs.URI;
						let decryptiv = keyAttrs.hexadecimalInteger('IV');
						let decryptkid = null;
						let decryptFormat = 'identity';
						let decryptFormatVersions = '1';

						//prepend trailing 0x and strip out hyphens if required
						if(keyAttrs['X-MLB-KEYID']) {
							let value = keyAttrs['X-MLB-KEYID'];

							if(value[0] !== '0' || value[1] !== 'x') {
								value = '0x' + value;
							}

							value = value.replace(/-/g, '');
							keyAttrs['X-MLB-KEYID'] = value;
							decryptkid = keyAttrs.hexadecimalInteger('X-MLB-KEYID');
						}

						if(keyAttrs.enumeratedString('KEYFORMAT')) {
							decryptFormat = keyAttrs.enumeratedString('KEYFORMAT');
						}

						if(keyAttrs.enumeratedString('KEYFORMATVERSIONS')) {
							decryptFormatVersions = keyAttrs.enumeratedString('KEYFORMATVERSIONS');
						}

						if (decryptmethod) {
							if(clearKeys) {
								//we are loading a new set of level keys for the next set of fragments, clear the old ones.
								//logger.log(`# Clearing old level keys`);
								levelkeys = [];
								clearKeys = false;
							}

							//logger.log(`# Creating levelKey for decryption method ${decryptmethod}`);
							let levelkey = new LevelKey();

							if ((decrypturi) && (['AES-128', 'SAMPLE-AES', 'ISO-23001-7', 'SAMPLE-AES-CTR', 'SAMPLE-AES-CENC'].indexOf(decryptmethod) >= 0)) {
								levelkey.method = decryptmethod;
					// URI to get the key
								levelkey.baseuri = baseurl;
								levelkey.reluri = decrypturi;
								levelkey.key = null;
					// Initialization Vector (IV)
								levelkey.iv = decryptiv;
								levelkey.kid = decryptkid;
								levelkey.format = decryptFormat;
								levelkey.formatVersions = decryptFormatVersions;
							}

							levelkeys.push(levelkey);
						}
					}
					break;
				case 'START':
					{
						let startParams = value1;
						let startAttrs = new AttrList(startParams);
						let startTimeOffset = startAttrs.decimalFloatingPoint('TIME-OFFSET');
				//TIME-OFFSET can be 0
						if ( !isNaN(startTimeOffset) ) {
							level.startTimeOffset = startTimeOffset;
						}
					}
					break;
				case 'MAP':
					{
						let mapAttrs = new AttrList(value1);
						let initFrag = new Fragment();
						initFrag.relurl = mapAttrs.URI;
						initFrag.rawByteRange = mapAttrs.BYTERANGE;
						initFrag.baseurl = baseurl;
						initFrag.level = id;
						initFrag.type = type;
						initFrag.sn = 'initSegment';
						initFrag.levelkeys = levelkeys;
						level.initSegment = initFrag;
					}
					break;

				default:
					logger.warn(`line parsed but not handled: ${result}`);
					break;
				}
			}
		}
		frag = prevFrag;
	//logger.log('found ' + level.fragments.length + ' fragments');
		if(frag && !frag.relurl) {
			level.fragments.pop();
			totalduration -= frag.duration;
		}

		if(level.fragments.length && !level.fragments[0].pdt) {
			let i;

			//this stream has no pdt, lets make one up
			//should be fine for vods, sliding windows ....
			level.fragments[0].rawProgramDateTime = '1997-08-29T00:00:00+00:00';
			level.fragments[0].pdt = Date.parse(level.fragments[0].rawProgramDateTime);

			for(i = 1; i < level.fragments.length; i++) {
				level.fragments[i].pdt = level.fragments[i - 1].pdt + level.fragments[i - 1].manifestDuration * 1000;
			}
		}

		level.totalduration = totalduration;
		level.averagetargetduration = totalduration / level.fragments.length;
		level.endSN = currentSN - 1;
		return level;
	}

	loadsuccess(response, stats, context) {
		let string = response.data;
		let url = response.url;
		let type = context.type;
		let id = context.id;
		let level = context.level;
		let hls = this.hls;

		//this.loaders[type] = undefined;
	// responseURL not supported on some browsers (it is used to detect URL redirection)
	// data-uri mode also not supported (but no need to detect redirection)
		if (url === undefined || url.indexOf('data:') === 0) {
			// fallback to initial URL
			url = context.url;
		}
		stats.tload = performance.now();
	//stats.mtime = new Date(target.getResponseHeader('Last-Modified'));
		if (string.indexOf('#EXTM3U') === 0) {
			if (string.indexOf('#EXTINF:') > 0) {
				let isLevel = (type !== 'audioTrack' && type !== 'subtitleTrack');
				let levelId = !isNaN(level) ? level : !isNaN(id) ? id : 0; // eslint-disable-line no-nested-ternary
				let levelDetails = this.parseLevelPlaylist(
					string,
					url,
					levelId,
					(type === 'audioTrack' ? 'audio' : (type === 'subtitleTrack' ? 'subtitle' : 'main') ) // eslint-disable-line no-nested-ternary
				);

				levelDetails.tload = stats.tload;
				if (type === 'manifest') {
					// first request, stream manifest (no master playlist), fire manifest loaded event with level details
					hls.trigger(Event.MANIFEST_LOADED, { levels: [{ url: url, details : levelDetails }], audioTracks : [], url: url, stats: stats });
				}
				stats.tparsed = performance.now();
				if (levelDetails.targetduration) {
					if (isLevel) {
						hls.trigger(Event.LEVEL_LOADED, { details: levelDetails, level: level || 0, id: id || 0, stats: stats });
					}
					else {
						if (type === 'audioTrack') {
							hls.trigger(Event.AUDIO_TRACK_LOADED, { details: levelDetails, id: id, stats: stats });
						}
						else if (type === 'subtitleTrack') {
							hls.trigger(Event.SUBTITLE_TRACK_LOADED, { details: levelDetails, id: id, stats: stats });
						}
					}
				}
				else {
					hls.trigger(Event.ERROR, {
						type: ErrorTypes.NETWORK_ERROR,
						details: ErrorDetails.MANIFEST_PARSING_ERROR,
						fatal: true,
						url: url,
						reason: 'invalid targetduration',
					});
				}
			}
			else {
				let levels = this.parseMasterPlaylist(string, url);
		// multi level playlist, parse level info
				if (levels.length) {
			/*
			let audioTracks = this.parseMasterPlaylistMedia(string, url, 'AUDIO');
			*/
					let audioTracks = this.parseMasterPlaylistMediaGrouped(string, url, 'AUDIO'); //Mactrix line changed, add rendition group support to audio tracks
					let subtitles = this.parseMasterPlaylistMedia(string, url, 'SUBTITLES');

					if (audioTracks.length) {
						// check if we have found an audio track embedded in main playlist (audio track without URI attribute)
						let embeddedAudioFound = false;
						audioTracks.forEach(audioTrack => {
							if(!audioTrack.url) {
								embeddedAudioFound = true;
							}
						});

						// if no embedded audio track defined, but audio codec signaled in quality level, we need to signal this main audio track
						// this could happen with playlists with alt audio rendition in which quality levels (main) contains both audio+video. but with mixed audio track not signaled
						if (embeddedAudioFound === false && levels[0].audioCodec && !levels[0].attrs.AUDIO) {
							logger.log('audio codec signaled in quality level, but no embedded audio track signaled, create one');
							audioTracks.unshift({ type : 'main', name : 'main' });
						}
					}
					hls.trigger(Event.MANIFEST_LOADED, { levels, audioTracks, subtitles, url, stats });
				}
				else {
					hls.trigger(Event.ERROR, {
						type: ErrorTypes.NETWORK_ERROR,
						details: ErrorDetails.MANIFEST_PARSING_ERROR,
						fatal: true,
						url: url,
						reason: 'no level found in manifest',
					});
				}
			}
		}
		else {
			hls.trigger(Event.ERROR, {
				type: ErrorTypes.NETWORK_ERROR,
				details: ErrorDetails.MANIFEST_PARSING_ERROR,
				fatal: true,
				url: url,
				reason: 'no EXTM3U delimiter',
			});
		}
	}

	loaderror(response, context) {
		let details;
		let fatal;
		let loader = context.loader;

		switch(context.type) {
		case 'manifest':
			details = ErrorDetails.MANIFEST_LOAD_ERROR;
			fatal = true;
			break;
		case 'level':
			details = ErrorDetails.LEVEL_LOAD_ERROR;
			fatal = false;
			break;
		case 'audioTrack':
			details = ErrorDetails.AUDIO_TRACK_LOAD_ERROR;
			fatal = false;
			break;
		}
		if (loader) {
			loader.abort();
			//this.loaders[context.type] = undefined;
			this.hls.trigger(Event.ERROR, {
				type: ErrorTypes.NETWORK_ERROR,
				details: details,
				fatal: fatal,
				url: loader.url,
				loader: loader,
				response: response,
				context : context,
			});
		}
		else {
			this.hls.trigger(Event.ERROR, {
				type: ErrorTypes.NETWORK_ERROR,
				details: details,
				fatal: fatal,
				response: response,
				context : context,
			});
		}
	}

	loadtimeout(stats, context) {
		let details;
		let	fatal;
		let	loader = context.loader;

		switch(context.type) {
		case 'manifest':
			details = ErrorDetails.MANIFEST_LOAD_TIMEOUT;
			fatal = true;
			break;
		case 'level':
			details = ErrorDetails.LEVEL_LOAD_TIMEOUT;
			fatal = false;
			break;
		case 'audioTrack':
			details = ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT;
			fatal = false;
			break;
		}
		if (loader) {
			loader.abort();
			//this.loaders[context.type] = undefined;
			this.hls.trigger(Event.ERROR, { type: ErrorTypes.NETWORK_ERROR, details: details, fatal: fatal, url: loader.url, loader: loader, context : context });
		}
		else {
			this.hls.trigger(Event.ERROR, { type: ErrorTypes.NETWORK_ERROR, details: details, fatal: fatal, context : context });
		}
	}
}

export default PlaylistLoader;



// WEBPACK FOOTER //
// ./src/hlsjs/loader/playlist-loader.js